import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { formatAmount } from '../../utils/formatAmount';
import useReport from './useReport';
import { formatDate } from '../../utils/dateUtils';

const WeightSummaryReport = () => {

  const {reportData, getWeightSummaryReport} = useReport() 

  useEffect(() => {
    getWeightSummaryReport()
  },[])

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow className='bg-indigo-600'>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รอบเรือ</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >น้ำหนักคลัง</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >น้ำหนัก Smile</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >% เรียกเก็บเงิน</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >% เก็บเงินสำเร็จ</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าน้ำหนักคลัง</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าน้ำหนัก Smile</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >กำไรค่าน้ำหนัก</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ราคาต่อ Kg</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {reportData && reportData.map((row) => (
            <TableRow key={row.shipDate}>
              <TableCell>{formatDate(row.shipDate)}</TableCell>
              <TableCell>{formatAmount(row.warehouseWeight)}</TableCell>
              <TableCell>{formatAmount(row.orderWeight)}</TableCell>
              <TableCell>
                {row.warehouseWeight == 0 || row.warehouseWeight == null
                  ? '0%'
                  : `${formatAmount(row.orderWeight * 100 / row.warehouseWeight)}%`}
              </TableCell>
              <TableCell>
                {row.warehouseWeight == 0 || row.warehouseWeight == null
                  ? '0%'
                  : `${formatAmount(row.orderWeightPaid * 100 / row.warehouseWeight)}%`}
              </TableCell>
              <TableCell>{formatAmount(row.warehouseWeightPrice)}</TableCell>
              <TableCell>{formatAmount(row.orderWeightPrice)}</TableCell>
              <TableCell>{formatAmount(row.orderWeightPrice - row.warehouseWeightPrice)}</TableCell>
              <TableCell>{formatAmount(row.warehouseWeightPrice/row.warehouseWeight)}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default WeightSummaryReport